import { IDropdownOption } from '@fluentui/react/lib/Dropdown';
import TimingType from '../store/schema/TimeSuggestionsTimingTypes';
import {
    timingNextAvailableOption,
    timingThisWeekOption,
    timingNextWeekOption,
} from '../components/SearchCriteriaDialog.locstring.json';
import loc from 'owa-localize';

export const timingDropdownOptions: IDropdownOption[] = [
    { key: TimingType.NextAvailable, text: loc(timingNextAvailableOption) },
    { key: TimingType.ThisWeek, text: loc(timingThisWeekOption) },
    { key: TimingType.NextWeek, text: loc(timingNextWeekOption) },
];
